<app-kymw1001 (childData)="logoutDisplaysHandler($event)"></app-kymw1001>


<div class="main-content">
  <div class="header">
    <span class="title">{{title}}</span>
    <div class="right-area">
      <ul class="user-info">
        <!--
        <li class="dept">
          <fa-icon [icon]="faBuilding"></fa-icon>
          <span class="name-label dept-name">{{userGroupName}}</span>
        </li>
        -->
        <!-- <li class="user">
          <fa-icon [icon]="faUser"></fa-icon>
          <span class="name-label user-name">{{userName}}</span>
        </li> -->
      </ul>
      <div class="logout" id="logout_div">
        <button type="button" class="fa-icon-button" [tabindex]="0">
          <fa-icon [icon]="faSignOutAlt" size="2x" (click)="logout()" ngbTooltip="ログアウト"></fa-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="body" (keydown)="onKeyDown($event)">
    <router-outlet></router-outlet>
  </div>
</div>

<app-function-menu></app-function-menu>